import React from "react";
import cx from "classnames";

const GenericRadioSelect = ({
  entities,
  newEntityLabel = null,
  onEntitySelected,
  selectedEntityID,
  RadioContentComponent,
  topAlignedCheckboxes = false,
}) => {
  if (!entities) {
    return null;
  }

  const onChange = e => {
    const val = e.target.value;

    onEntitySelected(val === "NEW" ? null : parseInt(val));
  };

  return (
    <div>
      {entities.map(entity => (
        <label
          className={cx(
            "gkit-d-flex gkit-flex-row gkit-mb-3",
            topAlignedCheckboxes ? "gkit-items-start" : "gkit-items-center"
          )}
          key={entity.id}
        >
          <input
            className="gkit-check-input gkit-me-3"
            type="radio"
            value={entity.id}
            checked={selectedEntityID === entity.id}
            onChange={onChange}
          />
          {<RadioContentComponent entity={entity} />}
        </label>
      ))}
      {newEntityLabel && (
        <label className="gkit-d-flex gkit-flex-row gkit-items-center">
          <input
            className="gkit-check-input gkit-me-3"
            type="radio"
            onChange={onChange}
            value="NEW"
            checked={selectedEntityID === null}
          />
          <p className="gkit-p-17 gkit-bold gkit-my-0">{newEntityLabel}</p>
        </label>
      )}
    </div>
  );
};

export default GenericRadioSelect;
